import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import Tools from "@root/ts/Tools";

export type CouponResult = {
  id: string,
  price: number,
  minus: number,
  faceMinus: number,
  unit: string
}

export default class Coupon extends ComponentBase {
  data: Common.CouponData;

  constructor(elem: ComponentElem, data?: Common.CouponData) {
    super(elem);

    if (data) {
      this.data = data;
      this.$root.attr("unit", Tools.parseBoolean(data.is_percentage) ? "percentage" : "number");
      this.$root.find(`.name`).text(data.name);
      this.$root.find(`.value`).text(data.value);
      this.$root.find(`.desc`).text(data.rule);
      this.$root.find(`.active-date`).text(data.active_date);
      this.$root.find(`.due-date`).text(data.due_date);
      this.$root.attr("is-selected", "false");
      this.toggleDisabled(Tools.parseBoolean(data.useable));
    }
  }

  caculatePrice(rawPrice: number): CouponResult {
    let price: number;
    let minus: number;
    let faceMinus: number;
    let unit: string;

    if (Tools.parseBoolean(this.data.is_percentage)) {
      unit = "percentage";
      minus = Math.round(rawPrice * ((10 - Tools.parseFloat(this.data.value)) / 10));
      price = rawPrice - minus;
      faceMinus = Tools.parseFloat(this.data.value);
    } else {
      unit = "number";
      faceMinus = minus = parseInt(this.data.value);
      price = Math.max(0, rawPrice - minus);
    }

    return {
      id: this.data.id,
      price: price,
      minus: minus,
      faceMinus: faceMinus,
      unit: unit
    };
  }

  toggleSelected(b: boolean) {
    this.$root.attr("is-selected", b ? "true" : "false");
  }

  toggleDisabled(b: boolean) {
    this.$root[0].setAttribute("disabled", b ? "false" : "true");
  }
}
